
const env = process.env.REACT_APP_ENV as 'development' | 'test' | 'production' | 'devProd';

// export const ROIAPI = env == 'development' ? 'http://localhost:9000' : 'https://wangwang.gamelexi.com';
//  http://192.168.50.229:9000
// export const ROIAPI = env === 'development' ? 'http://192.168.50.229:9000/' : 'https://wangwang.gamelexi.com';

export const ROIAPI = env === 'development' ? 
    'https://suibian.gamelexi.com'
    :
    ( 
        env === 'devProd' ?
        'https://suibian.gamelexi.com'
        :
        'https://wangwang.gamelexi.com'
    );

export const BingPullDataApi = env === 'development' ? 
    'https://juying.gamelexi.com' 
    :
    (
        env === 'devProd' ?
        'https://juying.gamelexi.com'
        :
        'https://juying.gamelexi.com'
    );